import {Business} from './Business';
import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person2Rounded';
import PhoneIcon from '@mui/icons-material/Phone';
import ElectricMeterIcon from '@mui/icons-material/ElectricMeter';
import BusinessIcon from '@mui/icons-material/Business';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ShareIcon from '@mui/icons-material/Share';
import {includes, isEmpty, toLower} from 'lodash';
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Collapse,
  Divider,
  Grid,
  IconButton,
  IconButtonProps, Link,
  styled,
  Typography
} from "@mui/material";
import {orange} from "@mui/material/colors";
import {ADMINS} from "./Constants";
import {AddLink} from "@mui/icons-material";


interface BusinessCardProps {
  business: Business;
  onEdit: (project: Business) => void;
  adminName: string;
}

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const {expand, ...other} = props;
  return <IconButton {...other} />;
})(({theme, expand}) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));
function BusinessCard(props: BusinessCardProps) {
  const { business, onEdit } = props;
  const handleEditClick = (businessBeingEdited: Business) => {
    console.log(businessBeingEdited);
    onEdit(businessBeingEdited);
  };
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
      <Card sx={{
        maxWidth: 330,
        borderRadius: '16px',
        border: '1px solid',
        borderColor: 'primary.main'
      }}>
        <CardHeader avatar={
          <Avatar sx={{bgcolor: orange[500], fontSize: "15px"}} aria-label="recipe">
            {business.shopNumber}
          </Avatar>}
                    title={business.ownerName}
                    subheader={business.lastUpdatedOn ? business.lastUpdatedOn.toISOString() : ''}
        ></CardHeader>
        <CardMedia component="img"
                   sx={{height: 200}}
                   image={business.imageUrl || "/assets/shop.png"}
                   alt={business.ownerName}></CardMedia>

        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {business.ownerName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {business.businessDescription}
          </Typography>
        </CardContent>
        <CardActions>
        {includes(ADMINS, toLower(props.adminName)) &&
            <IconButton aria-label="edit business" onClick={() => handleEditClick(business)}>
              <EditIcon/>
            </IconButton>
        }
          <IconButton aria-label="add to favorites">
            <FavoriteIcon/>
          </IconButton>
          <IconButton aria-label="share">
            <ShareIcon/>
          </IconButton>
          <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more">
            <ExpandMoreIcon/>
          </ExpandMore>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Divider/>
            <Typography fontSize={"large"} color="text.secondary">Owner</Typography>
            <Divider/>
            <Grid container direction="row" alignItems="center">
              <Grid item><PersonIcon/></Grid>
              <Grid item><Typography variant="body2" color="text.secondary">{`  ${business.ownerName}`}</Typography></Grid>
            </Grid>
            <Grid container direction="row" alignItems="center">
              <Grid item><PhoneIcon/></Grid>
              <Grid item><Typography variant="body2" color="text.secondary">{`  ${business.ownerContactNumber || 'N/A'}`}</Typography></Grid>
            </Grid>
            <Grid container direction="row" alignItems="center">
              { !isEmpty(business.ownerWhatsApp) && <Grid item><Link href={`https://wa.me/91${business.ownerWhatsApp}`} target={"_blank"}><WhatsAppIcon/></Link></Grid> }
              { isEmpty(business.ownerWhatsApp) && <Grid item><WhatsAppIcon/></Grid> }
              <Grid item><Typography variant="body2" color="text.secondary">{`  ${business.ownerWhatsApp || 'N/A'}`}</Typography></Grid>
            </Grid>
            <Grid container direction="row" alignItems="center">
              <Grid item><ElectricMeterIcon/></Grid>
              <Grid item> <Link target="_blank" rel="noreferrer" href={`https://www.billdesk.com/pgidsk/pgmerc/npdcl/NPDCLConfirm.jsp?custid=${business.electricityServiceNumber}&txtCustomerID=${business.electricityServiceNumber}&usncheck=true&txtAdditionalInfo1=0&txtAdditionalInfo2=0`}>Pay Electric Bill</Link></Grid>
            </Grid>
            <Divider/>
            <Typography fontSize={"large"} color="text.secondary">Business</Typography>
            <Divider/>
            <Grid container direction="row" alignItems="center">
              <Grid item><BusinessIcon/></Grid>
              <Grid item><Typography variant="body2" color="text.secondary">{`  ${business.businessName}`}</Typography></Grid>
            </Grid>
            <Grid container direction="row" alignItems="center">
              <Grid item><PhoneIcon/></Grid>
              <Grid item><Typography variant="body2" color="text.secondary">{`  ${business.businessContactNumber || 'N/A'}`}</Typography></Grid>
            </Grid>
            <Grid container direction="row" alignItems="center">
              { !isEmpty(business.businessWhatsApp) && <Grid item><Link href={`https://wa.me/91${business.businessWhatsApp}`} target={"_blank"}><WhatsAppIcon/></Link></Grid> }
              { isEmpty(business.businessWhatsApp) && <Grid item><WhatsAppIcon/></Grid> }
              <Grid item><Typography variant="body2" color="text.secondary">{`  ${business.businessWhatsApp || 'N/A'}`}</Typography></Grid>
            </Grid>
          </CardContent>
        </Collapse>
      </Card>
  );
}

export default BusinessCard;